import Vue from 'vue'
import './plugins/cube-ui'
import './plugins/vant'
import './plugins/antd'
import './plugins/element'
import './icons' // svg 图标
import WmqComponent from 'wmq-component'
import regestCustomForWmqComponent from '@/config/ui-config/custom-wmq-component'
import App from './App.vue'
import 'amfe-flexible'
import router from './router'
import store from './storage'

// 高德地图
import VueAMap from 'vue-amap'
import cube from 'cube-ui'
// 创建全局网络异常实例
import ServerError from './components/ServerError.vue'

import ToastNew from './components/Toast.vue'

import VTitle from './components/Title.vue'

import CustomLoading from './components/CustomLoading.vue'

// dayjs 时间插件
import dayjs from 'dayjs'

regestCustomForWmqComponent()
Vue.use(WmqComponent)
VueAMap.initAMapApiLoader({
  key: '1fde7d2149c9ad96139f1a29e1e65feb',
  plugin: ['DistrictSearch', 'Geolocation', 'Scale', 'ToolBar'],
  uiVersion: '1.0.11',
  v: '1.4.10'
})
Vue.use(VueAMap)

Vue.config.productionTip = false
cube.createAPI(Vue, ServerError, ['show', 'hide'], true)
cube.createAPI(Vue, ToastNew, ['show', 'hide'], true)
Vue.component('VTitle', VTitle)
Vue.component('CustomLoading', CustomLoading)

// 全局注册返回方法
Vue.prototype.goBack = function () {
  window.history.length > 1
    ? window.GlobalVue.$router.go(-1)
    : window.GlobalVue.$router.push('/')
}

// 全局注册自定义指令
Vue.directive('focus', {
  inserted: function (el, obj) {
    if (obj.value !== false) {
      el.focus()
    }
  }
})
Vue.prototype.$dayjs = dayjs

// 设置页面标题,demo时标题不同
if (window.location.href.indexOf('clbs.yiyao.cc') !== -1) {
  document.title = '终端通-未名企鹅GPS客户分析系统'
}

window.GlobalVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
